// NETBILLPAUSE1 (DEC-540): fills the "service is paused because ..." element. No imports, so the franchisor console bundle can use it
// without the floor application. Text by textContent only.

export interface BillingNoticeBody {
  paused?: boolean;
  message?: string | null;
  billingPath?: string | null;
}

/** Fills (or clears) a notice element from the server's answer. Shared by the floor app and the franchisor console. */
export function renderBillingNotice(
  node: HTMLElement,
  textNode: HTMLElement,
  linkNode: HTMLAnchorElement | null,
  body: BillingNoticeBody | null | undefined,
): void {
  const message = body?.paused === true && typeof body.message === "string" ? body.message : "";
  node.hidden = message === "";
  textNode.textContent = message;
  if (linkNode !== null) {
    const path = body?.billingPath;
    linkNode.hidden = message === "" || typeof path !== "string" || path === "";
    if (typeof path === "string" && path !== "") linkNode.href = path;
  }
}
